/**
 * Helpers for creating SuperAdmin Folders instance
 */

import type { IBaseSuperAdmin } from "../../BaseSuperAdminFactory";
import type { OfficeFolder } from "le-coffre-resources/dist/Notary";
import type { QueryPayload } from "../../../../types";
import type { IGetFoldersParams } from "../Folders";
import {
	createGetMethod,
	createGetByUidMethod,
	createPostMethod,
	createPutMethod,
	createDeleteMethod,
	createArchiveMethod,
	createRestoreMethod,
} from "./foldersMethodsHelpers";

export interface FoldersInstance {
	get(q: IGetFoldersParams): Promise<OfficeFolder[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<OfficeFolder>;
	post(officeFolder: Partial<OfficeFolder>): Promise<OfficeFolder>;
	put(uid: string, body: Partial<OfficeFolder>): Promise<OfficeFolder>;
	delete(uid: string): Promise<OfficeFolder>;
	archive(uid: string, body: Partial<OfficeFolder>): Promise<OfficeFolder>;
	restore(uid: string, body: Partial<OfficeFolder>): Promise<OfficeFolder>;
}

/**
 * Create Folders instance with all methods
 */
export function createFoldersInstance(baseSuperAdmin: IBaseSuperAdmin): FoldersInstance {
	const baseUrl = baseSuperAdmin.namespaceUrl.concat("/folders");

	return {
		get: createGetMethod(baseSuperAdmin, baseUrl),
		getByUid: createGetByUidMethod(baseSuperAdmin, baseUrl),
		post: createPostMethod(baseSuperAdmin, baseUrl),
		put: createPutMethod(baseSuperAdmin, baseUrl),
		delete: createDeleteMethod(baseSuperAdmin, baseUrl),
		archive: createArchiveMethod(baseSuperAdmin, baseUrl),
		restore: createRestoreMethod(baseSuperAdmin, baseUrl),
	};
}
